import React from 'react';
var StopMarker = function (_a) {
    var position = _a.position;
    return (React.createElement("div", { style: (_b = {},
            _b[position === 'left' ? 'left' : 'right'] = 0,
            _b[position === 'left' ? 'borderTopRightRadius' : 'borderTopLeftRadius'] = 16,
            _b.position = 'absolute',
            _b.bottom = 0,
            _b.width = 184,
            _b.height = 246,
            _b.background = '#E2001A',
            _b.fontSize = 60,
            _b.fontWeight = 700,
            _b.color = 'white',
            _b.textAlign = 'center',
            _b) }, "Stop"));
    var _b;
};
export default StopMarker;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/StopMarker.tsx
// module id = 1844
// module chunks = 0